export default {"src":"/polygon/_next/static/media/partner_10.85f98723.svg","height":121,"width":180};